// ==========================================================================
// testimonials
// ==========================================================================
(function () {
  function initTestimonialsSliders() {
    var viewports = document.querySelectorAll(
      '.rh-testimonials__viewport--slider'
    );

    if (!viewports.length) {
      return;
    }

    Array.prototype.forEach.call(viewports, function (viewport) {
      // Prevent duplicate initialization.
      if (viewport.dataset.rhSliderInitialized === 'true') {
        return;
      }

      var track = viewport.querySelector('.rh-testimonials__track');
      var cards = Array.prototype.slice.call(
        viewport.querySelectorAll('.rh-testimonials__card')
      );

      var prevBtn = viewport.querySelector('[data-rh-prev]');
      var nextBtn = viewport.querySelector('[data-rh-next]');

      var dots = Array.prototype.slice.call(
        viewport.querySelectorAll('[data-rh-dot]')
      );

      var section = viewport.closest('.rh-testimonials');

      var autoplay =
        section &&
        section.dataset.autoplay === 'true';

      var autoplaySpeed =
        (section &&
          parseInt(section.dataset.autoplaySpeed, 10)) ||
        5000;

      var currentIndex = 0;
      var autoplayTimer = null;
      var scrollTimeout = null;

      if (!track || cards.length < 1) {
        return;
      }

      viewport.dataset.rhSliderInitialized = 'true';

      // --------------------------------------------------------------------
      // Get slide position
      // --------------------------------------------------------------------

      function getSlidePosition(index) {
        var card = cards[index];

        if (!card) {
          return 0;
        }

        return card.offsetLeft - track.offsetLeft;
      }

      // --------------------------------------------------------------------
      // Update active slide
      // --------------------------------------------------------------------

      function updateActiveState(index) {
        currentIndex = index;

        cards.forEach(function (card, i) {
          card.setAttribute(
            'aria-hidden',
            i === index ? 'false' : 'true'
          );
        });

        dots.forEach(function (dot, i) {
          var isActive = i === index;

          dot.classList.toggle(
            'rh-testimonials__dot--active',
            isActive
          );

          dot.setAttribute(
            'aria-selected',
            isActive ? 'true' : 'false'
          );
        });
      }

      // --------------------------------------------------------------------
      // Go to slide
      // --------------------------------------------------------------------

      function goToSlide(index, smooth) {
        if (cards.length < 2) {
          return;
        }

        if (index < 0) {
          index = cards.length - 1;
        }

        if (index >= cards.length) {
          index = 0;
        }

        var left = getSlidePosition(index);

        track.scrollTo({
          left: left,
          behavior: smooth === false ? 'auto' : 'smooth'
        });

        updateActiveState(index);
      }

      // --------------------------------------------------------------------
      // Autoplay
      // --------------------------------------------------------------------

      function stopAutoplay() {
        if (autoplayTimer) {
          window.clearInterval(autoplayTimer);
          autoplayTimer = null;
        }
      }

      function startAutoplay() {
        if (!autoplay || cards.length < 2) {
          return;
        }

        stopAutoplay();

        autoplayTimer = window.setInterval(function () {
          goToSlide(currentIndex + 1);
        }, autoplaySpeed);
      }

      // --------------------------------------------------------------------
      // Previous
      // --------------------------------------------------------------------

      if (prevBtn) {
        prevBtn.addEventListener('click', function () {
          stopAutoplay();
          goToSlide(currentIndex - 1);
          startAutoplay();
        });
      }

      // --------------------------------------------------------------------
      // Next
      // --------------------------------------------------------------------

      if (nextBtn) {
        nextBtn.addEventListener('click', function () {
          stopAutoplay();
          goToSlide(currentIndex + 1);
          startAutoplay();
        });
      }

      // --------------------------------------------------------------------
      // Pagination dots
      // --------------------------------------------------------------------

      dots.forEach(function (dot, index) {
        dot.addEventListener('click', function () {
          stopAutoplay();
          goToSlide(index);
          startAutoplay();
        });
      });

      // --------------------------------------------------------------------
      // Detect manual scrolling / touch swipe
      // --------------------------------------------------------------------

      track.addEventListener(
        'scroll',
        function () {
          window.clearTimeout(scrollTimeout);

          scrollTimeout = window.setTimeout(function () {
            var scrollLeft = track.scrollLeft;

            var closestIndex = 0;
            var closestDistance = Infinity;

            cards.forEach(function (card, index) {
              var cardPosition =
                card.offsetLeft - track.offsetLeft;

              var distance = Math.abs(
                cardPosition - scrollLeft
              );

              if (distance < closestDistance) {
                closestDistance = distance;
                closestIndex = index;
              }
            });

            updateActiveState(closestIndex);
          }, 80);
        },
        {
          passive: true
        }
      );

      // --------------------------------------------------------------------
      // Pause on hover
      // --------------------------------------------------------------------

      viewport.addEventListener('mouseenter', function () {
        stopAutoplay();
      });

      viewport.addEventListener('mouseleave', function () {
        startAutoplay();
      });

      // --------------------------------------------------------------------
      // Pause while focused
      // --------------------------------------------------------------------

      viewport.addEventListener('focusin', function () {
        stopAutoplay();
      });

      viewport.addEventListener('focusout', function () {
        startAutoplay();
      });

      // --------------------------------------------------------------------
      // Initial state
      // --------------------------------------------------------------------

      updateActiveState(0);

      goToSlide(0, false);

      startAutoplay();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initTestimonialsSliders
    );
  } else {
    initTestimonialsSliders();
  }
})();